export const Tag = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1_5506)">
<path d="M17.1105 3.55888C17.4855 3.18381 17.9942 2.97309 18.5247 2.97309L27.01 2.97309C28.1145 2.97309 29.01 3.86852 29.01 4.97309L29.01 13.4584C29.01 13.9888 28.7992 14.4975 28.4242 14.8726L14.8072 28.4896C14.0261 29.2706 12.7598 29.2706 11.9787 28.4896L3.49345 20.0043C2.7124 19.2233 2.7124 17.9569 3.49345 17.1759L17.1105 3.55888Z" stroke="currentColor" stroke-width="2"/>
<circle cx="21.9833" cy="9.99975" r="3" transform="rotate(45 21.9833 9.99975)" stroke="currentColor" stroke-width="2"/>
</g>
<defs>
<clipPath id="clip0_1_5506">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>`;
